export interface FilterOption {
  readonly id: string;
  readonly label: string;
  readonly name: string;
}

// 1. 주문유형 필터
export const orderTypeFilters: FilterOption[] = [
  { id: "delivery", label: "배달", name: "orderType" },
  { id: "pickup", label: "포장", name: "orderType" },
  { id: "table", label: "매장", name: "orderType" },
];

// 2. 주문채널 필터
export const orderChannelFilters: FilterOption[] = [
  { id: "pos", label: "포스", name: "orderChannel" },
  { id: "cid", label: "전화", name: "orderChannel" },
  { id: "kiosk", label: "키오스크", name: "orderChannel" },
  { id: "okdc", label: "테이블오더", name: "orderChannel" },
  { id: "qrorder", label: "QR 오더", name: "orderChannel" },
  { id: "baemin", label: "배달의민족", name: "orderChannel" },
  { id: "coupang", label: "쿠팡이츠", name: "orderChannel" },
  { id: "yogiyo", label: "요기요", name: "orderChannel" },
  { id: "wmpo", label: "위메프오", name: "orderChannel" },
  { id: "specialdelivery", label: "배달특급", name: "orderChannel" },
  { id: "mukkebi", label: "먹깨비", name: "orderChannel" },
  { id: "ddangyo", label: "땡겨요", name: "orderChannel" },
  { id: "daeguro", label: "대구로", name: "orderChannel" },
  { id: "incheoneum", label: "인천이음", name: "orderChannel" },
  { id: "baedalys", label: "배달양산", name: "orderChannel" },
  { id: "naver", label: "네이버", name: "orderChannel" },
  { id: "panda", label: "헝그리판다", name: "orderChannel" },
  { id: "bmsmile", label: "위글루션", name: "orderChannel" },
  { id: "oltteaah", label: "올때아아", name: "orderChannel" },
  { id: "gamsungcoffee", label: "감성커피", name: "orderChannel" },
  { id: "routinecoffee", label: "루틴커피", name: "orderChannel" },
  { id: "talkpick", label: "톡포장", name: "orderChannel" },
  { id: "demonstration", label: "VD시연용", name: "orderChannel" },
  { id: "baegeokcoffee", label: "백억커피", name: "orderChannel" },
  { id: "baroder", label: "바로더", name: "orderChannel" },
  { id: "etc", label: "기타", name: "orderChannel" },
];

// 3. 결제수단 필터
export const paymentMethodFilters: FilterOption[] = [
  { id: "paid", label: "선불", name: "orderMeans" },
  { id: "paid_card", label: "후불카드", name: "orderMeans" },
  { id: "paid_cash", label: "후불현금", name: "orderMeans" },
];

// 4. 주문상태 필터
export const orderStatusFilters: FilterOption[] = [
  { id: "order_s", label: "완료", name: "orderState" },
  { id: "order_e", label: "취소", name: "orderState" },
];
